<template>
  <div class="view-doctors">
    <div class="view-doctors__container">
      <div class="view-doctors__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="view-doctors__column">
          <div class="view-doctors__title">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ pageTitle }}</h1>
          </div>
          <AppLoader v-if="isLoading"/>
          <div class="view-doctors__list-specialist">
            <nav v-if="departmentFilterVariant === 'list'" class="filter__body">
              <ul class="filter__list">
                <li class="filter__item" @click="filterSpecialists('Все специалисты')">
                  <p
                    class="text-TTDrugs-regular-14 text-uppercase"
                    :class="{ active: selectedFilter === 'Все специалисты' }"
                  >
                    Все специалисты
                  </p>
                </li>
                <li
                  v-for="department in departmentsWithSpecialists"
                  :key="department.id"
                  class="filter__item"
                  @click="filterSpecialists(departmentFilterKey(department))"
                >
                  <p
                    class="text-TTDrugs-regular-14 text-uppercase"
                    :class="{ active: selectedFilter === departmentFilterKey(department) }"
                  >
                    {{ department.name }}
                  </p>
                </li>
              </ul>
            </nav>

            <div
              class="view-doctors__search"
              :class="{ 'view-doctors__search--first': departmentFilterVariant === 'select' }"
            >
              <div class="view-doctors__search-title">
                <p class="text-TTDrugs-regular-16 color-gray">
                  Сотрудники КГБУЗ Алтайского краевого клинического перинатального центра "ДАР"
                </p>
              </div>
              <input
                v-model="searchQuery"
                type="text"
                :placeholder="searchPlaceholder"
                class="search-input-people text-circe-16"
              >
            </div>

            <div
              v-if="departmentFilterVariant === 'select'"
              class="specialists-catalog__filters"
            >
              <button
                type="button"
                class="specialists-catalog__filters-toggle"
                :aria-expanded="filtersExpanded ? 'true' : 'false'"
                @click="filtersExpanded = !filtersExpanded"
              >
                <span class="specialists-catalog__filters-toggle-text">
                  Фильтры
                  <span
                    v-if="activeFiltersCount"
                    class="specialists-catalog__filters-badge"
                  >{{ activeFiltersCount }}</span>
                </span>
                <span
                  class="specialists-catalog__filters-chevron"
                  :class="{ 'specialists-catalog__filters-chevron--open': filtersExpanded }"
                  aria-hidden="true"
                />
              </button>
              <div
                class="specialists-catalog__filters-row"
                :class="{ 'specialists-catalog__filters-row--open': filtersExpanded }"
              >
                <div class="specialists-catalog__filter">
                  <label class="specialists-catalog__filter-label text-TTDrugs-regular-14 text-uppercase">
                    Подразделение
                  </label>
                  <select v-model="departmentFilterValue" class="specialists-catalog__select text-circe-16">
                    <option value="Все специалисты">Все специалисты</option>
                    <option
                      v-for="department in departmentsWithSpecialists"
                      :key="department.id"
                      :value="departmentFilterKey(department)"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="specialists-catalog__filter">
                  <label class="specialists-catalog__filter-label text-TTDrugs-regular-14 text-uppercase">
                    Отделение
                  </label>
                  <select v-model="subDepartmentFilterValue" class="specialists-catalog__select text-circe-16">
                    <option value="">Все отделения</option>
                    <option
                      v-for="sub in availableSubDepartments"
                      :key="sub"
                      :value="sub"
                    >
                      {{ sub }}
                    </option>
                  </select>
                </div>
                <div class="specialists-catalog__filter">
                  <label class="specialists-catalog__filter-label text-TTDrugs-regular-14 text-uppercase">
                    Должность
                  </label>
                  <select v-model="selectedPositionFilter" class="specialists-catalog__select text-circe-16">
                    <option value="">Все должности</option>
                    <option
                      v-for="position in availablePositions"
                      :key="position"
                      :value="position"
                    >
                      {{ position }}
                    </option>
                  </select>
                </div>
                <div class="specialists-catalog__filter">
                  <label class="specialists-catalog__filter-label text-TTDrugs-regular-14 text-uppercase">
                    Квалификационная категория
                  </label>
                  <select v-model="selectedCategoryFilter" class="specialists-catalog__select text-circe-16">
                    <option value="">Все категории</option>
                    <option
                      v-for="category in availableCategories"
                      :key="category"
                      :value="category"
                    >
                      {{ category }}
                    </option>
                  </select>
                </div>
                <div class="specialists-catalog__filter">
                  <label class="specialists-catalog__filter-label text-TTDrugs-regular-14 text-uppercase">
                    Учёная степень
                  </label>
                  <select v-model="selectedDegreeFilter" class="specialists-catalog__select text-circe-16">
                    <option value="">Все учёные степени</option>
                    <option
                      v-for="degree in availableDegrees"
                      :key="degree"
                      :value="degree"
                    >
                      {{ degree }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="filteredDoctors && filteredDoctors.length">
        <slot name="list" :people="filteredDoctors"/>
      </div>
      <div v-else>
        <p class="text-TTDrugs-bold-24 color-gray center" style="margin-bottom: 20px">Специалистов не найдено*</p>
      </div>
    </div>
  </div>
</template>

<script>
import { actionTypesDepartment, mutationTypes } from '@/store/modules/department';
import { mapState } from 'vuex';
import AppLoader from '@/components/Loader.vue';
import DynamicMenu from '@/components/DynamicMenu.vue';
import menuItemsApi from '@/api/menuItems';
import DepartmentAPi from '@/api/department';

export default {
  name: 'SpecialistsCatalog',
  components: { DynamicMenu, AppLoader },
  props: {
    pageTitle: {
      type: String,
      default: 'Наши специалисты',
    },
    linksDepartment: {
      type: String,
      default: 'about/specialists',
    },
    menuSiblingsPath: {
      type: String,
      default: '/about/specialists',
    },
    departmentFilterVariant: {
      type: String,
      default: 'list',
      validator: (v) => ['list', 'select'].includes(v),
    },
    showSideMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dynamicMenuItems: [],
      searchQuery: '',
      selectedFilter: 'Все специалисты',
      subDepartmentFilter: null,
      selectedPositionFilter: '',
      selectedSubDepartmentFilter: '',
      selectedCategoryFilter: '',
      selectedDegreeFilter: '',
      catalogUnderDepartments: [],
      filtersExpanded: false,
    };
  },
  computed: {
    ...mapState({
      departments: (state) => state.department.departments,
      isLoading: (state) => state.department.isLoading,
      EMPLOYEES: (state) => state.department.EMPLOYEES,
      doctors: (state) => state.department.doctors,
      underDoctors: (state) => state.department.underDoctors,
    }),
    activeFiltersCount() {
      if (this.departmentFilterVariant !== 'select') {
        return 0;
      }
      let count = 0;
      if (this.selectedFilter && this.selectedFilter !== 'Все специалисты') {
        count += 1;
      }
      if (this.selectedSubDepartmentFilter) {
        count += 1;
      }
      if (this.selectedPositionFilter) {
        count += 1;
      }
      if (this.selectedCategoryFilter) {
        count += 1;
      }
      if (this.selectedDegreeFilter) {
        count += 1;
      }
      return count;
    },
    filteredDoctors() {
      let list = this.baseFilteredDoctors;
      if (this.departmentFilterVariant !== 'select') {
        return list;
      }
      // Подотделение: список уже через API → underDoctors (subDepartmentFilter)
      if (this.selectedPositionFilter) {
        list = list.filter(
          (d) => String(d.position || '').trim() === this.selectedPositionFilter
        );
      }
      if (this.selectedCategoryFilter) {
        list = list.filter(
          (d) => this.getPersonCategory(d) === this.selectedCategoryFilter
        );
      }
      if (this.selectedDegreeFilter) {
        list = list.filter(
          (d) => this.getPersonDegree(d) === this.selectedDegreeFilter
        );
      }
      return this.sortSpecialistsByHierarchy(list);
    },
    baseFilteredDoctors() {
      let list;
      if (this.subDepartmentFilter) {
        list = this.underDoctors;
      } else if (this.selectedFilter === 'Все специалисты') {
        const hasSearch = String(this.searchQuery || '').trim().length > 0;
        if (this.departmentFilterVariant === 'select' && !hasSearch) {
          // Все роли (главврач, замы, зав. и т.д.), иначе в «Все» только EMPLOYEE
          list = this.flattenAllCatalogPeople();
          if (!list.length) {
            list = this.EMPLOYEES;
          }
        } else {
          // Поиск пишет результат в EMPLOYEES
          list = this.EMPLOYEES;
        }
      } else {
        list = this.doctors;
      }

      const idFromRoute = this.$route.query?.specialistId;
      if (idFromRoute != null && String(idFromRoute).trim() && list?.length > 1) {
        const idStr = String(idFromRoute).trim();
        const exact = list.filter(
          (d) =>
            d.id === idStr ||
            String(d.id) === idStr ||
            Number(d.id) === Number(idStr)
        );
        if (exact.length === 1) {
          return exact;
        }
      }

      return list || [];
    },
    availablePositions() {
      return this.collectUniqueFieldValues((person) =>
        String(person.position || '').trim()
      );
    },
    availableSubDepartments() {
      if (this.departmentFilterVariant !== 'select') {
        return [];
      }
      return (this.catalogUnderDepartments || [])
        .map((ud) => String(ud.title || ud.name || '').trim())
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, 'ru'));
    },
    availableCategories() {
      return this.collectUniqueFieldValues((person) =>
        this.getPersonCategory(person)
      );
    },
    availableDegrees() {
      return this.collectUniqueFieldValues((person) =>
        this.getPersonDegree(person)
      );
    },
    searchPlaceholder() {
      return this.departmentFilterVariant === 'select'
        ? 'Поиск по имени или фамилии врача'
        : 'Введите фамилию или имя врача...';
    },
    showDynamicMenu() {
      if (!this.showSideMenu) {
        return false;
      }
      return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
    },
    /**
     * Подразделения, в которых есть хотя бы один специалист (по mainDepartment).
     * Пустые (как «ЭКО ДОНОРСТВО» без сотрудников) в фильтр не попадают.
     * Пока каталог людей ещё не загружен — показываем все, чтобы не мигал пустой select.
     */
    departmentsWithSpecialists() {
      const list = this.departments || [];
      const people = this.flattenAllCatalogPeople();
      if (!people.length) {
        return list;
      }
      const namesWithPeople = new Set(
        people
          .map((p) => String(p.mainDepartment || '').trim())
          .filter(Boolean)
      );
      return list.filter((d) =>
        namesWithPeople.has(String(d.name || '').trim())
      );
    },
    departmentFilterValue: {
      get() {
        if (
          this.selectedFilter === 'Все специалисты' ||
          this.departmentsWithSpecialists.some(
            (d) => this.departmentFilterKey(d) === this.selectedFilter
          )
        ) {
          return this.selectedFilter;
        }
        // selectedFilter мог стать именем подотдела из query — в select показываем «Все»
        return 'Все специалисты';
      },
      set(val) {
        this.filterSpecialists(val);
      },
    },
    subDepartmentFilterValue: {
      get() {
        return this.selectedSubDepartmentFilter;
      },
      set(val) {
        this.onSubDepartmentFilterChange(val);
      },
    },
  },
  watch: {
    searchQuery(val) {
      this.performFioSearch(val);
    },
    '$route.query.specialist': {
      immediate: true,
      handler(val) {
        if (typeof val === 'string' && val.trim()) {
          this.searchQuery = val.trim();
        }
      },
    },
    '$route.query.subDepartment': {
      immediate: true,
      handler() {
        this.applySubDepartmentFromRoute();
      },
    },
  },
  mounted() {
    this.$store.dispatch(actionTypesDepartment.getDepartment)
      .then(() => {
        if (!this.$route.query?.subDepartment) {
          this.fetchGetAllDoctors();
          this.applySpecialistFromRoute();
        }
      })
      .catch((er) => {
        console.log('Ошибка', er);
      });
    if (this.showSideMenu) {
      this.loadSiblingsForMenu();
    }
  },
  methods: {
    getPersonCategory(person) {
      return String(
        person.qualificationCategory ||
          person.qualification_category ||
          person.category ||
          ''
      ).trim();
    },
    getPersonDegree(person) {
      return String(
        person.academicDegree || person.academic_degree || ''
      ).trim();
    },
    /**
     * 0 главный врач → 1 заместители → 2 заведующие → 3 врачи →
     * 4 главная акушерка → 5 старшие акушерки → 6 старшие сёстры → 7 остальные
     */
    specialistHierarchyRank(person) {
      const raw = String((person && person.position) || '')
        .toLowerCase()
        .replace(/ё/g, 'е')
        .trim();
      if (!raw) {
        return 7;
      }
      if (raw.includes('заместител') && raw.includes('главн')) {
        return 1;
      }
      if (raw === 'главный врач' || raw.startsWith('главный врач ')) {
        return 0;
      }
      if (raw.includes('заведующ')) {
        return 2;
      }
      if (raw.startsWith('врач')) {
        return 3;
      }
      if (raw.includes('главн') && raw.includes('акушерк')) {
        return 4;
      }
      if (raw.includes('старш') && raw.includes('акушерк')) {
        return 5;
      }
      if (raw.includes('старш') && raw.includes('сестр')) {
        return 6;
      }
      return 7;
    },
    sortSpecialistsByHierarchy(list) {
      if (!Array.isArray(list) || list.length < 2) {
        return list || [];
      }
      return list.slice().sort((a, b) => {
        const rankDiff =
          this.specialistHierarchyRank(a) - this.specialistHierarchyRank(b);
        if (rankDiff !== 0) {
          return rankDiff;
        }
        const nameA = String((a && a.name) || '').trim();
        const nameB = String((b && b.name) || '').trim();
        return nameA.localeCompare(nameB, 'ru', { sensitivity: 'base' });
      });
    },
    collectUniqueFieldValues(getter) {
      if (this.departmentFilterVariant !== 'select') {
        return [];
      }
      const values = new Set();
      (this.baseFilteredDoctors || []).forEach((person) => {
        const value = getter(person);
        if (value) {
          values.add(value);
        }
      });
      return Array.from(values).sort((a, b) => a.localeCompare(b, 'ru'));
    },
    resetAttributeFilters() {
      this.selectedPositionFilter = '';
      this.selectedSubDepartmentFilter = '';
      this.selectedCategoryFilter = '';
      this.selectedDegreeFilter = '';
    },
    /**
     * Ключ фильтра подразделения: links, либо name если links пустой.
     * Иначе 15+ подразделений с links="" схлопываются в одно пустое value.
     */
    departmentFilterKey(department) {
      if (!department) {
        return '';
      }
      const links = String(department.links || '').trim();
      if (links) {
        return links;
      }
      return String(department.name || '').trim();
    },
    findDepartmentByFilterKey(filterKey) {
      const key = String(filterKey || '').trim();
      if (!key || key === 'Все специалисты') {
        return null;
      }
      return (
        (this.departments || []).find(
          (d) => this.departmentFilterKey(d) === key
        ) || null
      );
    },
    flattenAllCatalogPeople() {
      const grouped = this.$store.state.department.allDoctors;
      const people = [];
      const seen = new Set();
      const pushList = (list) => {
        if (!Array.isArray(list)) {
          return;
        }
        list.forEach((person) => {
          if (!person || person.id == null || seen.has(person.id)) {
            return;
          }
          seen.add(person.id);
          people.push(person);
        });
      };
      if (grouped && typeof grouped === 'object' && !Array.isArray(grouped)) {
        Object.values(grouped).forEach(pushList);
      }
      if (!people.length) {
        pushList(this.EMPLOYEES);
      }
      return people;
    },
    async ensureAllDoctorsLoaded() {
      const grouped = this.$store.state.department.allDoctors;
      const hasGrouped =
        grouped &&
        typeof grouped === 'object' &&
        !Array.isArray(grouped) &&
        Object.values(grouped).some((v) => Array.isArray(v) && v.length);
      if (hasGrouped) {
        return;
      }
      await this.$store.dispatch(actionTypesDepartment.getAllDoctors);
    },
    async filterDoctorsByMainDepartmentName(departmentName) {
      const name = String(departmentName || '').trim();
      this.$store.commit(mutationTypes.getDoctorsDepartmentStart);
      try {
        await this.ensureAllDoctorsLoaded();
        const filtered = this.flattenAllCatalogPeople().filter(
          (person) => String(person.mainDepartment || '').trim() === name
        );
        this.$store.commit(mutationTypes.getDoctorsDepartmentSuccess, filtered);
      } catch (e) {
        console.error('filterDoctorsByMainDepartmentName', e);
        this.$store.commit(mutationTypes.getDoctorsDepartmentFailure, e);
      }
    },
    async loadCatalogUnderDepartments(filterKey) {
      if (this.departmentFilterVariant !== 'select') {
        this.catalogUnderDepartments = [];
        return;
      }
      if (!filterKey || filterKey === 'Все специалисты') {
        this.catalogUnderDepartments = [];
        return;
      }
      const dept = this.findDepartmentByFilterKey(filterKey);
      // Публичный API: GET /sub-department/{name} ищет отделение по name, не по id
      const departmentName = dept && String(dept.name || '').trim();
      if (!departmentName) {
        this.catalogUnderDepartments = [];
        return;
      }
      try {
        const res = await DepartmentAPi.getUnderDepartment(departmentName);
        const body = res && res.data !== undefined ? res.data : res;
        let list = [];
        if (body && body.status === 'SUCCESS' && Array.isArray(body.result)) {
          list = body.result;
        } else if (Array.isArray(body)) {
          list = body;
        } else if (body && Array.isArray(body.result)) {
          list = body.result;
        }
        this.catalogUnderDepartments = list;
      } catch (e) {
        console.error('loadCatalogUnderDepartments', e);
        this.catalogUnderDepartments = [];
      }
    },
    onSubDepartmentFilterChange(val) {
      const next = String(val || '').trim();
      this.selectedSubDepartmentFilter = next;
      if (this.departmentFilterVariant !== 'select') {
        return;
      }
      if (next) {
        this.subDepartmentFilter = next;
        this.getDoctorsUnderDepartment(next);
        return;
      }
      this.subDepartmentFilter = null;
      this.reloadDoctorsForCurrentDepartment();
    },
    reloadDoctorsForCurrentDepartment() {
      if (
        this.selectedFilter === 'Все специалисты' ||
        !this.findDepartmentByFilterKey(this.selectedFilter)
      ) {
        this.fetchGetAllDoctors();
        return;
      }
      this.loadDoctorsForDepartmentFilter(this.selectedFilter);
    },
    applySpecialistFromRoute() {
      const specialist = this.$route.query?.specialist;
      if (typeof specialist === 'string' && specialist.trim()) {
        this.searchQuery = specialist.trim();
      }
    },
    applySubDepartmentFromRoute() {
      const sub = this.$route.query?.subDepartment;
      if (typeof sub === 'string' && sub.trim()) {
        this.subDepartmentFilter = sub.trim();
        this.selectedSubDepartmentFilter = sub.trim();
        this.getDoctorsUnderDepartment(sub.trim());
        return;
      }
      this.subDepartmentFilter = null;
      if (
        this.selectedFilter &&
        this.selectedFilter !== 'Все специалисты' &&
        !this.findDepartmentByFilterKey(this.selectedFilter)
      ) {
        this.selectedFilter = 'Все специалисты';
      }
    },
    filterSpecialists(mainDepartment) {
      this.subDepartmentFilter = null;
      this.selectedFilter = mainDepartment;
      this.resetAttributeFilters();
      this.loadCatalogUnderDepartments(mainDepartment);
      if (mainDepartment === 'Все специалисты') {
        this.fetchGetAllDoctors();
        return;
      }
      this.loadDoctorsForDepartmentFilter(mainDepartment);
    },
    loadDoctorsForDepartmentFilter(filterKey) {
      const dept = this.findDepartmentByFilterKey(filterKey);
      const links = dept && String(dept.links || '').trim();
      if (links) {
        this.getDoctorsDepartment(links);
        return;
      }
      const name = dept
        ? String(dept.name || '').trim()
        : String(filterKey || '').trim();
      this.filterDoctorsByMainDepartmentName(name);
    },
    getDoctorsDepartment(item) {
      this.$store.dispatch(actionTypesDepartment.getDoctorsDepartment, item)
        .catch((er) => {
          console.log('Ошибка', er);
        });
    },
    getDoctorsUnderDepartment(name) {
      this.$store.dispatch(actionTypesDepartment.getDoctorsUnderDepartment, name)
        .catch((er) => {
          console.log('Ошибка', er);
        });
    },
    fetchGetAllDoctors() {
      this.$store.dispatch(actionTypesDepartment.getAllDoctors);
    },
    performFioSearch(fio) {
      const trimmed = String(fio || '').trim();
      if (!trimmed) {
        this.$store.dispatch(actionTypesDepartment.getAllDoctors);
        return;
      }
      const parts = trimmed.split(/\s+/).filter(Boolean);
      const searchTerm = parts.length > 1 ? parts[0] : trimmed;
      this.$store.dispatch(actionTypesDepartment.getSearchFio, searchTerm);
    },
    async loadSiblingsForMenu() {
      try {
        const response = await menuItemsApi.getSiblingsByTo(this.menuSiblingsPath);

        if (response.data.status === 'SUCCESS') {
          this.dynamicMenuItems = response.data.result
            .map((item) => {
              const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

              return {
                text: item.label,
                link: item.to,
                slug,
                active: slug === this.linksDepartment,
                id: item.id,
                order: item.order || 0,
              };
            })
            .sort((a, b) => (a.order || 0) - (b.order || 0));
        }
      } catch (error) {
        console.error('Ошибка при загрузке меню:', error);
      }
    },
  },
};
</script>

<style>
.view-doctors__search {
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 0;
}

.view-doctors__search--first {
  margin-top: 0;
}

.view-doctors__search-title {
  margin: 0 0 15px 0;
}

.search-input-people {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
  box-shadow: none;
  outline: none;
}

.specialists-catalog__filters {
  width: 100%;
  max-width: 100%;
  margin-top: 16px;
  box-sizing: border-box;
}

.specialists-catalog__filters-toggle {
  display: none;
}

.specialists-catalog__filters-row {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: end;
  gap: 12px 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.specialists-catalog__filter {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.specialists-catalog__filter-label {
  margin: 0;
  color: #6b7280;
  font-family: "TTDrugs", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: 0.02em;
}

.specialists-catalog__select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 10px 36px 10px 12px;
  font-family: "Circe", sans-serif;
  font-size: 16px;
  line-height: 1.35;
  color: #1a1a1a;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236b7280' d='M1.4 0.6L6 5.2 10.6 0.6 12 2 6 8 0 2z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 8px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-shadow: none;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
}

.specialists-catalog__select:focus {
  outline: 2px solid rgba(56, 97, 58, 0.2);
  outline-offset: 1px;
}

@media (max-width: 1100px) {
  .specialists-catalog__filters-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .specialists-catalog__filters-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  /* Специфичнее глобального [class*="__container"], иначе padding: 20px перекрывает */
  .view-doctors.view-doctors {
    padding-top: 24px;
  }

  .view-doctors .view-doctors__container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .view-doctors .view-doctors__row {
    margin-bottom: 16px;
    max-width: none;
  }

  .view-doctors .view-doctors__title {
    margin-bottom: 12px;
  }

  .view-doctors .view-doctors__title h1 {
    font-size: 28px;
    line-height: 1.15;
  }

  .specialists-catalog__filters-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background: #fff;
    font-family: "TTDrugs", sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #38613a;
    cursor: pointer;
    box-sizing: border-box;
  }

  .specialists-catalog__filters-toggle-text {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .specialists-catalog__filters-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border-radius: 11px;
    background: #38613a;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
  }

  .specialists-catalog__filters-chevron {
    width: 10px;
    height: 10px;
    border-right: 2px solid #38613a;
    border-bottom: 2px solid #38613a;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
    flex-shrink: 0;
    margin-top: -4px;
  }

  .specialists-catalog__filters-chevron--open {
    transform: rotate(-135deg);
    margin-top: 4px;
  }

  .specialists-catalog__filters-row {
    display: none;
    margin-top: 12px;
  }

  .specialists-catalog__filters-row--open {
    display: grid;
    grid-template-columns: 1fr;
  }

  .specialists-catalog__filter {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 479.98px) {
  .view-doctors .view-doctors__container {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
